/**
 * 工具方法及过滤器
 * 
 * 仅可使用this.$config
 * $utils调用时，this指向utils本身，挂载了$config对象
 * 作为过滤器调用时，this为挂载了$config的空对象
 */

// 解析资源路径
export function resolveResPath(path) {
  const resPattern = /^(\\|\/)(upload|resources)(\\|\/)/;
  if(typeof path === 'string' && !path.startsWith('http') && resPattern.test(path)) {
    return `${this.$config.publicResourceURL}/${path}`;
  } else {
    return path;
  }
}

export default {
  resolveResPath
}